import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1189,
      "name": "sk.svg",
      "url": "https://api.strachanresort.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  }
];
